<template>
  <FormContainer withoutDivider>
    <template #title>Informations salarié(e)</template>
    <template #content>
      <!-- Déactiver recherche PRT-640 -->
      <div
        class="form__bloc"
        v-if="!readonly && saisieAdherent && false"
      >
        <RechercheSalarie
          mode="salaries"
          :id-demande="model!.id"
          @selected="onRechercheSalarie"
          class="col-12 col-md-18 col-sm-36"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_51"
          v-model="nomNaissanceModel"
          label="Nom de naissance"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :required="meta.salarie?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nomNaissance?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_52"
          v-model="nomUsageModel"
          label="Nom d'usage (si différent)"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :required="meta.salarie?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_53"
          v-model="prenomModel"
          label="Prénom (le premier selon l'état civil)"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :required="meta.salarie?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.prenom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_54"
          key="sexe-dropdown"
          v-model="sexeModel"
          label="Sexe"
          class="col-7 col-md-12 col-sm-36"
          :items="sexeItems"
          :readonly
          :required="meta.salarie?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.sexe?.$messageErreurDirty!"
        />
        <WrapperInputDate
          id="field_55"
          v-model="dateNaissanceModel"
          label="Date de naissance"
          :hint="HINT_DATE"
          class="col-8 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :required="meta.salarie?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.dateNaissance?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInput
          id="field_58"
          v-model="departementNaissanceModel"
          label="Département de naissance"
          hint="3 caractères maximum"
          class="col-9 col-md-12 col-sm-36"
          placeholder="Ex : 75"
          :maxlength="3"
          deletable
          :required="meta.salarie?.departementNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.departementNaissance?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInput
          id="field_59"
          v-model="communeNaissanceModel"
          label="Commune de naissance"
          class="col-12 col-md-12 col-sm-36"
          placeholder="Ex: Paris"
          :maxlength="50"
          deletable
          :required="meta.salarie?.communeNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.communeNaissance?.$messageErreurDirty!"
          :readonly
        />
      </div>
      <div
        class="form__bloc"
        v-if="alertPlus26AnsLabel"
      >
        <BasicAlert
          v-if="alertPlus26AnsLabel"
          alertType="warning"
          :alertLabel="alertPlus26AnsLabel"
          class="col-36 col-md-36 col-sm-36"
        />
      </div>

      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_57"
          v-model="nirTemporaireModel"
          label="Êtes-vous détenteur d'un NIR temporaire ?"
          :required="meta.salarie?.nirTemporaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nirTemporaire?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          help="Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale"
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperInput
          id="field_56"
          v-model="nirModel"
          :label="nirLabel"
          :hint="nirHint"
          class="col-10 col-md-12 col-sm-36"
          placeholder="Ex : 1234567890123"
          :required="meta.salarie?.nir?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nir?.$messageErreurDirty!"
          :maxlength="nirMaxLength"
          deletable
          :readonly
          :help="nirHelp"
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_60"
          v-model="handicapeModel"
          label="Qualité de travailleur handicapé"
          :items="OuiOuNon"
          :required="meta.salarie?.beneficieReconnaissanceTravailleurHandicape?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.beneficieReconnaissanceTravailleurHandicape?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <BasicText class="col-36">
          <strong style="text-decoration: underline">Si non</strong>
          , bénéficiez-vous de droits attachés à la RQTH:
        </BasicText>
        <div class="col-10 col-md-14 col-sm-36 flex">
          <WrapperToggleSwitch
            v-if="meta.salarie?.equivalenceJeune?.$status !== PropertyStatus.NotPresent"
            v-model="equivalenceJeuneModel"
            label="Équivalence jeunes"
            :items="OuiOuNon"
            :required="meta.salarie?.equivalenceJeune?.$status === PropertyStatus.Required"
            :alertLabel="meta.salarie?.equivalenceJeune?.$messageErreurDirty!"
            :readonly
            class="flex-1"
          />
          <WrapperToggleSwitch
            v-else
            label="Équivalence jeunes"
            :items="OuiOuNon"
            disabled
            class="flex-1"
          />
          <basic-button
            class="flex-none align-self-flex-end help-btn"
            type="primary"
            _iconName="help"
            variant="filled"
            label="?"
            @click="helpEquivalenceJeune = true"
          />
          <teleport to="#app">
            <modal-component
              closable
              v-model="helpEquivalenceJeune"
            >
              <template #header>
                <BasicText size="h4">Equivalence jeunes</BasicText>
              </template>
              <template #content>
                <div
                  class="flex flex-column flex-gap-4"
                  style="max-width: 600px"
                >
                  <p>
                    <BasicText>
                      Pour les personnes âgées de 15 ans révolus à 20 ans, les titres suivants valent RQTH et ouvrent
                      aux aménagements du contrat d’apprentissage (cf. article L. 5213-2 du code du travail).
                    </BasicText>
                  </p>
                  <ul>
                    <li>
                      <BasicText size="body-l">
                        Notification de la Prestation de Compensation du Handicap (PCH)
                      </BasicText>
                    </li>
                    <li>
                      <BasicText size="body-l">
                        Notification de l’Allocation d’Education de l’Enfant Handicapé (AEEH)
                      </BasicText>
                    </li>
                    <li>
                      <BasicText size="body-l">Le bénéfice d’un projet Personnalisé de Scolarisation (PPS)</BasicText>
                    </li>
                  </ul>
                  <p>
                    <BasicText>
                      Si vous bénéficiez de l’un de ces titres, indiquez « OUI » au champ « Equivalence jeunes » du
                      cerfa.
                    </BasicText>
                  </p>
                </div>
              </template>
            </modal-component>
          </teleport>
        </div>
        <div class="col-10 col-md-14 col-sm-36 flex">
          <WrapperToggleSwitch
            v-if="meta.salarie?.extensionBOE?.$status !== PropertyStatus.NotPresent"
            v-model="extensionBOEModel"
            label="Extension BOE"
            :items="OuiOuNon"
            :required="meta.salarie?.extensionBOE?.$status === PropertyStatus.Required"
            :alertLabel="meta.salarie?.extensionBOE?.$messageErreurDirty!"
            :readonly
            class="col-10 col-md-14 col-sm-36"
          />
          <WrapperToggleSwitch
            v-else
            label="Extension BOE"
            :items="OuiOuNon"
            disabled
            class="col-10 col-md-14 col-sm-36"
          />
          <basic-button
            class="flex-none align-self-flex-end help-btn"
            type="primary"
            _iconName="help"
            variant="filled"
            label="?"
            @click="helpExtensionBOEModel = true"
          />
          <teleport to="#app">
            <modal-component
              closable
              v-model="helpExtensionBOEModel"
            >
              <template #header>
                <basic-text size="h4">Extension BOE</basic-text>
              </template>
              <template #content>
                <div
                  class="flex flex-column flex-gap-4"
                  style="max-width: 600px"
                >
                  <p>
                    <basic-text>
                      A compter du 1er janvier 2024, les droits liés à la RQTH sont étendus aux personnes bénéficiaires
                      de l'obligation d'emploi (BOE) hors ayants-droits (cf. article L. 5212-13-1 du code du travail) :
                      il convient de cocher OUI au champ « Extension BOE » du cerfa pour bénéficier des aménagements
                      prévus pour les apprentis en situation de handicap.
                    </basic-text>
                  </p>
                </div>
              </template>
            </modal-component>
          </teleport>
        </div>
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_37"
          v-model="cspModel"
          label="Catégorie socio-professionnelle (CSP)"
          class="col-16 col-md-18 col-sm-36"
          :items="lov.Csp"
          :required="meta.salarie?.csp?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.csp?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_74"
          v-model="inscritPoleEmploiModel"
          label="Inscrit à France Travail ?"
          :required="meta.salarie?.inscritPoleEmploi?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.inscritPoleEmploi?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperInput
          v-if="meta.salarie?.numeroInscriptionPoleEmploi?.$status !== PropertyStatus.NotPresent"
          id="field_75"
          v-model="numeroInscriptionPoleEmploiModel"
          label="Si oui, renseignez le numéro d'inscription"
          class="col-10 col-md-14 col-sm-36"
          :required="meta.salarie?.numeroInscriptionPoleEmploi?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.numeroInscriptionPoleEmploi?.$messageErreurDirty!"
          :readonly
          :maxlength="12"
        />
        <WrapperInput
          v-else
          id="field_75"
          label="Si oui, renseignez le numéro d'inscription"
          class="col-10 col-md-14 col-sm-36"
          disabled
        />
        <WrapperInputNumber
          v-if="meta.salarie?.dureeMoisPoleEmploi?.$status !== PropertyStatus.NotPresent"
          id="field_76"
          v-model="dureeMoisPoleEmploiModel"
          label="Durée d'inscription (en mois)"
          :required="meta.salarie?.dureeMoisPoleEmploi?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.dureeMoisPoleEmploi?.$messageErreurDirty!"
          class="col-10 col-md-14 col-sm-36"
          :readonly
          :decimal="0"
        />
        <WrapperInputNumber
          v-else
          id="field_76"
          label="Durée d'inscription (en mois)"
          class="col-10 col-md-14 col-sm-36"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_71"
          v-model="situationAvantContratModel"
          label="Situation avant contrat"
          :required="meta.salarie?.situationAvantContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.situationAvantContrat?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.SituationAvantContrat"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_72"
          v-model="typeMinimuSocialModel"
          label="Type de minimum social, si bénéficiaire"
          :required="meta.salarie?.typeMinimuSocial?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.typeMinimuSocial?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.TypeMinimumSocial"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_70"
          v-model="diplomePlusEleveModel"
          label="Diplôme ou titre le plus élevé obtenu"
          :required="meta.salarie?.diplomeOuTitreLePlusEleveObtenu?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.diplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.Diplome"
          :readonly
          key-id="code"
          key-label="intitule"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import {
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_DATE_NAIS,
    PLACEHOLDER_NOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_PRENOM,
  } from '@/features/interface/demande/shared'
  import { objectIsEmpty, OuiOuNon, sexeItems } from '@/features/interface/shared/tools'
  import { CPRO_INJECT, type DemandeCproActions } from '../../../../DemandeCPRO.type'
  import { RechercheSalarie } from '@/features/interface/demande/shared/components/salaries'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import type { SalarieRechercheDTO } from '@/features/api/extranet/dto/Demande/shared'
  import { type DialogResult, useDialog } from '@/features/interface/dialog'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'

  const store = useDemandeCPROStore()
  const { setupFieldWithKey } = store
  const { model, meta, lov, readonly, typeContextCourant } = storeToRefs(store)

  const { alertPlus26AnsLabel, patchRemplacerSalarié } = inject<DemandeCproActions>(CPRO_INJECT)!
  const saisieAdherent = computed(() => typeContextCourant.value === TypesContextesAutorisesEnum.Adherent)

  const nirMaxLength = computed(() => {
    return model.value?.salarie?.nirTemporaire === true ? 40 : 13
  })

  const nirHint = computed(() => {
    return model.value?.salarie?.nirTemporaire === true ? '11 à 40 caractères' : '13 caractères'
  })

  const nirHelp = computed(() => {
    return model.value?.salarie?.nirTemporaire === true
      ? "Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale."
      : 'Le numéro de sécurité sociale est inscrit sur la carte vitale, en dessous du nom et du prénom du porteur.'
  })

  const nirLabel = computed(() => {
    return model.value?.salarie?.nirTemporaire === true
      ? 'Numéro technique temporaire'
      : 'Numéro de sécurité sociale (NIR)'
  })

  const nomNaissanceModel = setupFieldWithKey<string>('salarie.nomNaissance', true)
  const nomUsageModel = setupFieldWithKey<string>('salarie.nom', true)
  const prenomModel = setupFieldWithKey<string>('salarie.prenom', true)
  const nirTemporaireModel = setupFieldWithKey<boolean>('salarie.nirTemporaire', false)
  // TODO si l'option temporaire (NTT) est cochée, modifier le libellé du NIR par "N° technique temporaire"
  // NIR 13 ou 15, appel api si code commence pas par 3,4,7,8
  // clé de luhne 2 chiffre caractére 14 et 15 facultatif
  // appel api uniquement avec NIR
  // verifier donnée age/departement  etc, par rapport au NIR
  const nirModel = setupFieldWithKey<string>('salarie.nir', true)

  const dateNaissanceModel = setupFieldWithKey<string>('salarie.dateNaissance', true)
  const departementNaissanceModel = setupFieldWithKey<string>('salarie.departementNaissance', true)
  const communeNaissanceModel = setupFieldWithKey<string>('salarie.communeNaissance', true)
  const handicapeModel = setupFieldWithKey<boolean>('salarie.beneficieReconnaissanceTravailleurHandicape', false)
  const cspModel = setupFieldWithKey<string>('salarie.csp', false)
  const sexeModel = setupFieldWithKey<string>('salarie.sexe', false)
  const inscritPoleEmploiModel = setupFieldWithKey<boolean>('salarie.inscritPoleEmploi', false)

  const numeroInscriptionPoleEmploiModel = setupFieldWithKey<string>('salarie.numeroInscriptionPoleEmploi', true)
  const dureeMoisPoleEmploiModel = setupFieldWithKey<string>('salarie.dureeMoisPoleEmploi', true)

  const situationAvantContratModel = setupFieldWithKey<string>('salarie.situationAvantContrat', false)
  const typeMinimuSocialModel = setupFieldWithKey<string>('salarie.typeMinimuSocial', false)
  const diplomePlusEleveModel = setupFieldWithKey<string>('salarie.diplomeOuTitreLePlusEleveObtenu', false)

  const equivalenceJeuneModel = setupFieldWithKey<boolean>('salarie.equivalenceJeune')
  const extensionBOEModel = setupFieldWithKey<boolean>('salarie.extensionBOE')
  const helpEquivalenceJeune = ref(false)
  const helpExtensionBOEModel = ref(false)

  const onRechercheSalarie = async (value: SalarieRechercheDTO) => {
    let reponse: DialogResult = 'Ok'

    if (objectIsEmpty(model.value?.salarie, { exclude: ['source'] }) === false) {
      const dialog = useDialog()
      reponse = await dialog.showDialog({
        message: ['Cette opération entrainera le remplacement de la saisie existante.', "Confirmez-vous l'opération ?"],
        type: 'OkCancel',
        closable: true,
        title: 'Attention',
      })
    }
    if (reponse === 'Ok') {
      patchRemplacerSalarié(value)
    }
  }
</script>
